<template>
  <div
    class="mb-4 flex items-center bg-blue-50 border-l-4 border-blue-400 p-4 rounded"
  >
    <span v-html="INFO_ICON" class="w-6 h-6 text-blue-400 flex-shrink-0"></span>
    <span class="ml-3 text-base text-gray-700 leading-normal">
      To invite expert via your own software like CRM or marketing automation
      platforms you can copy and paste this link anywhere. The icons/buttons
      below will open up these software login pages to make it easier for you.
      You have the option to decide if you want the signup link to go to your
      customized program landing page first or directly to the profile signup
      form. After you send the invites you can check the expert status in the
      Experts tab.
    </span>
  </div>
  <div class="flex flex-col gap-2 w-full bg-white rounded-lg p-4 shadow">
    <InviteByLinkSection
      invitationType="experts"
      :directSignup="directSignup"
      :showInstructions="false"
      class="mb-2"
    />
    <span class="font-medium text-sm mb-2">
      OR Use Your Software to Invite Experts
    </span>
    <div class="flex flex-wrap gap-3 items-center">
      <button
        v-for="software in softwareList"
        :key="software.id"
        class="p-2 bg-gray-100 rounded hover:bg-primary-purple hover:text-white transition"
        @click="$emit('software-click', software)"
      >
        <img :src="software.icon" :alt="software.name" class="w-8 h-8" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import InviteByLinkSection from "./InviteByLinkSection.vue";
import { INFO_ICON } from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "InviteViaSoftwareSection",
  components: {
    InviteByLinkSection,
  },
  props: {
    softwareList: {
      type: Array as PropType<
        Array<{ id: string; name: string; icon: string }>
      >,
      required: true,
    },
    directSignup: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    return {
      INFO_ICON,
    };
  },
});
</script>
